import { NavLink } from 'react-router';
import { t } from '../../i18n';
import { useMe } from '../../lib/auth';
import { can } from '../../lib/permissions';
import { canSeeLicenses, canSeeSuppliers } from '../licenses/data';
import { canSeeAll, isHr } from './data';

const link = ({ isActive }: { isActive: boolean }) => `-mb-px border-b-2 px-3 py-2 text-sm ${isActive ? 'border-marca font-medium text-slate-900' : 'border-transparent text-slate-600 hover:text-slate-900'}`;

/** Secciones del módulo Usuarios y licencias: altas, bajas y Mi equipo para todos; el resto, según los permisos. */
export function PeopleNav() {
  const me = useMe();
  return (
    <nav aria-label={t('us.secciones')} className="flex flex-wrap gap-1 border-b border-slate-200">
      {isHr(me) && (
        <NavLink to="/usuarios/portal" className={link}>
          {t('us.portal_corto')}
        </NavLink>
      )}
      <NavLink to="/usuarios/altas" className={link}>
        {t('us.altas')}
      </NavLink>
      <NavLink to="/usuarios/bajas" className={link}>
        {t('us.bajas')}
      </NavLink>
      <NavLink to="/usuarios/equipo" className={link}>
        {t('us.equipo')}
      </NavLink>
      {canSeeAll(me) && (
        <NavLink to="/usuarios/directorio" className={link}>
          {t('us.directorio')}
        </NavLink>
      )}
      {canSeeLicenses(me) && (
        <NavLink to="/licencias" className={link}>
          {t('li.titulo')}
        </NavLink>
      )}
      {canSeeSuppliers(me) && (
        <NavLink to="/proveedores" className={link}>
          {t('pv.titulo')}
        </NavLink>
      )}
      {can(me, 'usuarios.gestionar') && (
        <NavLink to="/usuarios/importar" className={link}>
          {t('us.importar_corto')}
        </NavLink>
      )}
    </nav>
  );
}
